module.exports = __webpack_public_path__ + "img/8_65.307d8b57.png";